export function deleteIcon(fill) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 5.30951C4.5 5.03337 4.72386 4.80951 5 4.80951H14.1667C14.4428 4.80951 14.6667 5.03337 14.6667 5.30951C14.6667 5.58565 14.4428 5.80951 14.1667 5.80951H5C4.72386 5.80951 4.5 5.58565 4.5 5.30951Z"
        fill="#2d70e2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77344 4.65475C7.77344 4.37861 7.9973 4.15475 8.27344 4.15475H10.8925C11.1686 4.15475 11.3925 4.37861 11.3925 4.65475C11.3925 4.9309 11.1686 5.15475 10.8925 5.15475H8.27344C7.9973 5.15475 7.77344 4.9309 7.77344 4.65475Z"
        fill="#2d70e2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6543 7.42856C5.93044 7.42856 6.1543 7.65242 6.1543 7.92856V14.6309H13.0114V7.92923L13.5114 7.92856L14.0114 7.92863V15.6309H5.1543V7.92856C5.1543 7.65242 5.37815 7.42856 5.6543 7.42856ZM13.5114 7.92856L14.0114 7.92863C14.0114 7.65249 13.7876 7.42856 13.5114 7.42856C13.2353 7.42856 13.0114 7.65309 13.0114 7.92923L13.5114 7.92856Z"
        fill="#2d70e2"
      />
    </svg>
  );
}

export function downloadIcon(fill) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 4.5C10.7761 4.5 11 4.72386 11 5V13.125C11 13.4011 10.7761 13.625 10.5 13.625C10.2239 13.625 10 13.4011 10 13.125V5C10 4.72386 10.2239 4.5 10.5 4.5Z"
        fill="#2d70e2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.02145 10.2714C7.21671 10.0762 7.53329 10.0762 7.72855 10.2714L10.5 13.0429L13.2714 10.2714C13.4667 10.0762 13.7833 10.0762 13.9786 10.2714C14.1738 10.4667 14.1738 10.7833 13.9786 10.9786L10.5 14.4571L7.02145 10.9786C6.82618 10.7833 6.82618 10.4667 7.02145 10.2714Z"
        fill="#2d70e2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 16.25C5 15.9739 5.22386 15.75 5.5 15.75H15.5C15.7761 15.75 16 15.9739 16 16.25C16 16.5261 15.7761 16.75 15.5 16.75H5.5C5.22386 16.75 5 16.5261 5 16.25Z"
        fill="#2d70e2"
      />
    </svg>
  );
}

export function caretDown(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.64645 9.64062C7.84171 9.45313 8.15829 9.45313 8.35355 9.64062L12 13.142L15.6464 9.64062C15.8417 9.45313 16.1583 9.45313 16.3536 9.64062C16.5488 9.82812 16.5488 10.1321 16.3536 10.3196L12 14.5L7.64645 10.3196C7.45118 10.1321 7.45118 9.82812 7.64645 9.64062Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export function caretUp(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.64645 9.64062C7.84171 9.45313 8.15829 9.45313 8.35355 9.64062L12 13.142L15.6464 9.64062C15.8417 9.45313 16.1583 9.45313 16.3536 9.64062C16.5488 9.82812 16.5488 10.1321 16.3536 10.3196L12 14.5L7.64645 10.3196C7.45118 10.1321 7.45118 9.82812 7.64645 9.64062Z"
          fill={fill}
          transform="rotate(180 12 12)"
        />
      </g>
    </svg>
  );
}

export function viewIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z"
        stroke="#2d70e2"
        stroke-linecap="round"
      />
      <circle cx="12" cy="12" r="3" stroke="#2d70e2" stroke-linecap="round" />
    </svg>
  );
}

export function userIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Name=Accountability">
        <path
          id="Stroke 1 Copy (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.14036 7.24992C6.74144 7.74862 6.5 8.55353 6.5 9.75C6.5 11.5034 7.01846 12.3286 7.41536 12.8049C7.5074 12.9154 7.59464 13.009 7.6809 13.1016C7.69441 13.1161 7.7079 13.1306 7.72138 13.1451C7.81141 13.2421 7.92187 13.3618 8.00262 13.4874C8.08802 13.6203 8.17818 13.8168 8.14673 14.0594C8.11634 14.2938 7.98478 14.4723 7.85355 14.6036C7.42238 15.0347 6.89771 15.3445 6.38767 15.5996C6.13163 15.7276 5.87105 15.8457 5.62329 15.9579L5.61875 15.96C5.36951 16.0728 5.13398 16.1795 4.91111 16.291C4.45746 16.5178 4.10468 16.7416 3.86447 17.0096C3.63925 17.2608 3.5 17.5648 3.5 18C3.5 18.2761 3.27614 18.5 3 18.5C2.72386 18.5 2.5 18.2761 2.5 18C2.5 17.3102 2.73575 16.7705 3.1199 16.342C3.48907 15.9302 3.98004 15.6385 4.46389 15.3965C4.70408 15.2764 4.95453 15.163 5.19756 15.0529L5.2107 15.047C5.46098 14.9336 5.7043 14.8232 5.94046 14.7051C6.39042 14.4801 6.78505 14.2412 7.09657 13.9451C7.06979 13.914 7.03476 13.8753 6.98858 13.8256C6.97662 13.8127 6.96411 13.7993 6.95112 13.7853C6.86532 13.6933 6.75823 13.5784 6.64714 13.4451C6.10654 12.7964 5.5 11.7466 5.5 9.75C5.5 8.44672 5.75843 7.37663 6.35945 6.62527C6.97753 5.85259 7.88951 5.5 9 5.5C10.1105 5.5 11.0225 5.85259 11.6405 6.62527C12.2416 7.37663 12.5 8.44672 12.5 9.75C12.5 11.7466 11.8935 12.7964 11.3529 13.4451C11.2418 13.5784 11.1347 13.6933 11.0489 13.7853C11.0359 13.7993 11.0234 13.8127 11.0114 13.8256C10.9652 13.8753 10.9302 13.914 10.9034 13.9451C11.215 14.2412 11.6096 14.4801 12.0595 14.7051C12.2957 14.8232 12.539 14.9336 12.7893 15.047L12.8024 15.0529C13.0455 15.163 13.2959 15.2764 13.5361 15.3965C14.02 15.6385 14.5109 15.9302 14.8801 16.342C15.2643 16.7705 15.5 17.3102 15.5 18C15.5 18.2761 15.2761 18.5 15 18.5C14.7239 18.5 14.5 18.2761 14.5 18C14.5 17.5648 14.3607 17.2608 14.1355 17.0096C13.8953 16.7416 13.5425 16.5178 13.0889 16.291C12.866 16.1795 12.6305 16.0728 12.3812 15.96L12.3767 15.9579C12.1289 15.8457 11.8684 15.7276 11.6123 15.5996C11.1023 15.3445 10.5776 15.0347 10.1464 14.6036C10.0152 14.4723 9.88366 14.2938 9.85327 14.0594C9.82182 13.8168 9.91198 13.6203 9.99738 13.4874C10.0781 13.3618 10.1886 13.2421 10.2786 13.1451C10.2921 13.1306 10.3056 13.1161 10.3191 13.1016C10.4054 13.009 10.4926 12.9154 10.5846 12.8049C10.9815 12.3286 11.5 11.5034 11.5 9.75C11.5 8.55353 11.2586 7.74862 10.8596 7.24992C10.4778 6.77254 9.88976 6.5 9 6.5C8.11024 6.5 7.52222 6.77254 7.14036 7.24992Z"
          fill="#666D79"
        />
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3621 2.65517C21.5525 2.85514 21.5448 3.17163 21.3448 3.36207L16.8 7.69048L14.6552 5.64778C14.4552 5.45734 14.4475 5.14085 14.6379 4.94089C14.8284 4.74092 15.1449 4.7332 15.3448 4.92365L16.8 6.30953L20.6552 2.63793C20.8551 2.44749 21.1716 2.45521 21.3621 2.65517Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function editIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Name=Edit">
        <path
          id="Rectangle 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.3313 4.54761C16.186 3.69289 17.5718 3.69289 18.4265 4.54761L19.4522 5.57328C20.3069 6.428 20.3069 7.81378 19.4522 8.6685L9.82211 18.2986C9.41165 18.709 8.85496 18.9396 8.27449 18.9396L5.06017 18.9396L5.06017 15.7253C5.06017 15.1448 5.29076 14.5881 5.70121 14.1777L15.3313 4.54761ZM17.8075 5.16666C17.2946 4.65382 16.4632 4.65382 15.9503 5.16666L6.32026 14.7967C6.07399 15.043 5.93563 15.377 5.93563 15.7253L5.93564 18.0642L8.27449 18.0642C8.62277 18.0642 8.95679 17.9258 9.20306 17.6795L18.8331 8.04946C19.346 7.53663 19.346 6.70516 18.8331 6.19233L17.8075 5.16666Z"
          fill="#666D79"
        />
        <path
          id="Path 9 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.0104 10.48L13.4287 6.8983L14.0619 6.26514L17.6436 9.84686L17.0104 10.48Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function deletePulseIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 5.30951C4.5 5.03337 4.72386 4.80951 5 4.80951H14.1667C14.4428 4.80951 14.6667 5.03337 14.6667 5.30951C14.6667 5.58565 14.4428 5.80951 14.1667 5.80951H5C4.72386 5.80951 4.5 5.58565 4.5 5.30951Z"
        fill="#666D79"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77344 4.65475C7.77344 4.37861 7.9973 4.15475 8.27344 4.15475H10.8925C11.1686 4.15475 11.3925 4.37861 11.3925 4.65475C11.3925 4.9309 11.1686 5.15475 10.8925 5.15475H8.27344C7.9973 5.15475 7.77344 4.9309 7.77344 4.65475Z"
        fill="#666D79"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6543 7.42856C5.93044 7.42856 6.1543 7.65242 6.1543 7.92856V14.6309H13.0114V7.92923L13.5114 7.92856L14.0114 7.92863V15.6309H5.1543V7.92856C5.1543 7.65242 5.37815 7.42856 5.6543 7.42856ZM13.5114 7.92856L14.0114 7.92863C14.0114 7.65249 13.7876 7.42856 13.5114 7.42856C13.2353 7.42856 13.0114 7.65309 13.0114 7.92923L13.5114 7.92856Z"
        fill="#666D79"
      />
    </svg>
  );
}

export function scheduleIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Name=Send">
        <path
          id="Triangle (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.62071 10.5669C3.32876 10.6622 3.22142 11.0247 3.42186 11.2384L6.33689 14.3463L12.7394 10.6283C12.907 10.531 13.1132 10.5578 13.2372 10.693C13.3612 10.8283 13.3702 11.0363 13.259 11.1952L9.03765 17.2258L12.0606 20.4488C12.2611 20.6625 12.6296 20.5786 12.7435 20.2934L18.2629 6.46003C18.3897 6.14211 18.1043 5.83777 17.7789 5.94401L3.62071 10.5669ZM2.81143 11.8109C2.21013 11.1698 2.53213 10.0824 3.40797 9.79646L17.5662 5.17357C18.5423 4.85484 19.3987 5.76788 19.0181 6.72164L13.4987 20.555C13.1573 21.4107 12.0515 21.6625 11.4502 21.0214L8.21053 17.5673C8.08392 17.4323 8.07366 17.2223 8.18584 17.062L11.5746 12.2208L6.43332 15.2064C6.26716 15.3029 6.06281 15.2775 5.93838 15.1448L2.81143 11.8109Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function backIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8374 6.14645C16.0542 6.34171 16.0542 6.65829 15.8374 6.85355L9.5698 12.5L15.8374 18.1464C16.0542 18.3417 16.0542 18.6583 15.8374 18.8536C15.6207 19.0488 15.2693 19.0488 15.0525 18.8536L8 12.5L15.0525 6.14645C15.2693 5.95118 15.6207 5.95118 15.8374 6.14645Z"
        fill="#666D79"
      />
    </svg>
  );
}